<script>
import { mapGetters } from 'vuex'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'Pay',
    meta: [{ name: 'description', content: '' }],
  },
  components: {
    Layout,
  },
  computed: {
    ...mapGetters({
      brand: 'contentful/getBrand',
      content: 'contentful/getContent',
    }),
    homeImage() {
      return this.brand?.homeImage?.fields?.file?.url
    },
    logo() {
      return this.brand?.logo?.fields?.file?.url
    },
    termsLink() {
      return this.brand?.termsConditionsUrl || this.content?.termsConditionsUrl
    },
    introActionLabel() {
      return this.brand?.introActionLabel || this.content?.introActionLabel
    },
  },
}
</script>

<template>
  <Layout hide-header :loading="false" screen="home">
    <div :class="$style.container">
      <BaseLink :to="{ name: 'table-input' }">
        <div :class="$style.container">
          <img v-if="logo" :class="$style.logo" :src="logo" />
          <img
            v-else
            :class="$style.logo"
            src="@assets/images/logo-served.png"
          />
          <img v-if="homeImage" :class="$style.bgMiddle" :src="homeImage" />
          <img
            v-else
            :class="$style.bgMiddle"
            src="@assets/images/home-middle.png"
          />
        </div>
      </BaseLink>

      <div v-if="content" class="footer">
        <BaseLink :to="{ name: 'table-input' }">
          <BaseButton v-text="introActionLabel" />
        </BaseLink>
        <div :class="$style.spacer">
          <BaseLink v-if="termsLink" :href="termsLink">
            Terms & Conditions
          </BaseLink>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.logo {
  padding-top: 40px;
  width: 160px;
}

.background {
  width: 100%;
}

.bgMiddle {
  margin-top: 16px;
  max-height: 50vh;
  max-width: 70vw;
  padding-bottom: 20px;
}

.spacer {
  margin: 20px 0;
}
</style>
